export default __webpack_public_path__ + "media/images/coworkr/favicons/icon70-313feed741482fff757dc0198dc95cda.png";